/**
 * ---------------------------------------------------------------------
 * VEU frontend-visitors app
 * ---------------------------------------------------------------------
 * @author seven-m.de
 * @copyright SEVEN M 2020
 */
/*
 * ---------------------------------------------------------------------
 * import modules
 * ---------------------------------------------------------------------
 */
import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PopoverAppointments from 'src/shared_modules/veu-visitors-core/components/appointments/index';

/*
 * ---------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------
 * PopoverProvider React Component
 * ---------------------------------------------------------------------
 */
class AppointmentsProvider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logging: (process.env.REACT_APP_DEPLOY_ENV !== 'live'),
        };
    }

    componentDidMount() {

    }

    render() {
        let { pathname } = this.props.location;
        let popoverAllowed = !pathname.endsWith("/home");

        return (<React.Fragment>
                    { this.props.popovers.showAppointments && popoverAllowed && <PopoverAppointments /> }
                </React.Fragment>);
    }
}
/*
 * ---------------------------------------------------------------------
 * App prop Types
 * ---------------------------------------------------------------------
 */
AppointmentsProvider.propTypes = {
    popovers: PropTypes.object,
};
/*
 * ---------------------------------------------------------------------
 * App Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = (state, ownProps) => {
    return {
        popovers: state.popovers,
    };
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
    mapStateToProps,
)(withRouter(AppointmentsProvider));
